import type { FaireProductEntity } from "../../entity_types/product";

export const p_zq6tmtyza7: FaireProductEntity = {
  token: "p_zq6tmtyza7",
  type: "product",
  name: "Gold Evil Eye Enamel Statement Ring, Adjustable",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl: "https://cdn.faire.com/fastly/ba3cfc99679c82dd90f0edd44df79c4e6eb41ad1b25809f3e158547a6b08d81e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0bab815050643025f36902b9948dd60cf7104ba78b6b51bd107dd1c968c42574.jpeg",
    "https://cdn.faire.com/fastly/e46d527ba4376ac2078d3916aa2bae2309af7748cf227cfc6dc0ca93a2ac3696.jpeg",
    "https://cdn.faire.com/fastly/87efb133fa9c8dc642447f6fd344daaca82dd13799994a4c9ee7f18fc9fa06e4.jpeg",
    "https://cdn.faire.com/fastly/338d2b5f79e46a0ac19a1418af75a41b34b9a51ec0bb72779ccfd5603494ab2b.jpeg",
    "https://cdn.faire.com/fastly/941d86a215906f46bb2256996ffca754d95e96fe3d0ba268560215937cd970b7.jpeg"
  ],
  priceDollars: 9.42,
  description: "Creating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive price!\nTake a look at more detail information about this item:\n\nSuch a cute and Bold Link ring! It's a Chunky, everyday ring that is elegant, chic, and trendy. It is perfect for all ages, and as a gift.\nThis listing is for ONE Adjustable ring only.\n\nDescription: \nMaterial: Brass Based with 18K Gold Filled, Enamel\nSize: 22x22mm\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nIf you any questions regarding our products, bulk discount, and issue please send us a message\n\nThank you for your visit!\n\n",
  tags: [],
  msrpDollars: 11.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:23.076Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
